import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import ModalCompanyDialog from '../pyns/ModalCompanyDialog';
import { Link } from 'react-router-dom';
import M from 'materialize-css';
import { useFirestore } from 'react-redux-firebase';
import CompanyItem from './CompanyItem';
import { companiesRef } from '../../api/fbCollections';

const refModal = React.createRef();

const SelectCompany = forwardRef((props, ref) => {
  const firestore = useFirestore();
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState(null);
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const { country, changeCompany } = props;

  useEffect(() => M.AutoInit(), []);

  useEffect(() => loadCompanies(firestore), [firestore]);

  const loadCompanies = (firestore) => {
    firestore
      .collection(companiesRef)
      .get()
      .then((querySnapshot) => {
        const companies = [];
        querySnapshot.forEach((doc) => {
          companies.push({ id: doc.id, ...doc.data() });
        });
        setCompanies(companies);
      });
  };

  const openCompanyDialog = () => {
    const modal = M.Modal.getInstance(refModal.current);
    modal.open();
  };

  const search = (searchTerm) => {
    filterCompanies(country, searchTerm);
  };

  const filterCompanies = (country, companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return (
        company.countryCode === country &&
        (companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true)
      );
    });
    setCurrentCompanies(filteredCompanies);
  };

  const getCompany = () => company;

  useImperativeHandle(ref, () => ({
    getCompany: getCompany,
  }));

  return (
    <div>
      <div className="row">
        <div className="input-field">
          <CompanyItem company={company} />
          <div className="col s6">
            <Link to="#" onClick={() => openCompanyDialog()}>
              Select company
            </Link>
          </div>
        </div>
      </div>
      <ModalCompanyDialog
        refModal={refModal}
        search={search}
        currentCompanies={currentCompanies}
        setCompany={(company) => {
          setCompany(company);
          if (changeCompany) {
            changeCompany(company);
          }
        }}
      />
    </div>
  );
});

export default SelectCompany;
